import * as Yup from 'yup';

const email = Yup.string().email('Correo inválido').required('El campo es obligatorio.');

const patente_regex = /^[a-z]{2}[\.\- ]?[0-9]{2}[\.\- ]?[0-9]{2}|[b-d,f-h,j-l,p,r-t,v-z]{2}[\-\. ]?[b-d,f-h,j-l,p,r-t,v-z]{2}[\.\- ]?[0-9]{2}$/i;
const patente = Yup.string().required('El campo es obligatorio.')
                    .test('valida-patente', 'Patente incorrecta', function(value) {
                     
                      return patente_regex.test(value);
                    });

/* Esquemas de validacion de Yup para utilizar en Formik */
export const buscarCasosFormSchema = (required, defaultDate) => {
    
    let validationObject = { };
   
    for (let key in required) {
        
        switch (key) {
            case "fechadesde":
                validationObject[key] = Yup.date().default(new Date(defaultDate.desde)).required('El campo es obligatorio.').max(Yup.ref('fechahasta'), 'Fecha desde debe ser menor a la fecha hasta');
                break;
            case "fechahasta":
                validationObject[key] = Yup.date().default(new Date(defaultDate.hasta)).required('El campo es obligatorio.').max(new Date(), 'Fecha hasta no puede ser mayor a la fecha actual');
                break;
            case "patente":
                validationObject[key] = patente;
                break;
            default:
                validationObject[key] = Yup.string().required('El campo es obligatorio.');
                break;
        }
    }

    return Yup.object().shape(validationObject);
}


/*
<Formik 
  initialValues={{ email: '', showEmail: false }}
  validationSchema={Yup.object().shape({
    showEmail: Yup.boolean(),
    email: Yup
      .string()
      .email()
      .when("showEmail", {
        is: true,
        then: Yup.string().required("Must enter email address")
      })
  })
}
/>
*/